export default __webpack_public_path__ + "static/media/shoulder.2da70af9.jpg";